/*globals google*/
(function () { 
angular.module('invesfleet')
    .directive('addressMap', addressMap);

    addressMap.$inject = ['ModalService', '$templateCache', 'NgMap', '$rootScope', '$q', 'endPoints', '$timeout'];

    function addressMap(ModalService, $templateCache, NgMap, $rootScope, $q, endPoints, $timeout) {
        
        return {
            restrict: 'A',
            scope: {
                address: '=?',
                country: '=?',
                state: '=?',
                city: '=?',
                cp: '=?',
                lat: '=?',
                long: '=?',
                onChange: '&?',
                onAddressChange: '&?',
                autocomplete: '=?',
            },
            link: function(scope, element, attrs){
                
                scope.googleApiURL = endPoints.GOOGLE_MAPS_API_URL;
                var modalTemplate = $templateCache.get('app/views/modals/mapAddressTemplate.html');

                element.bind('click', function(){
                    /* jshint camelcase:false */
                    ModalService.showModal({
                        template: modalTemplate,
                        controller:
                        function ($scope, close) {
                            var city, province, country, cp;

                            var def = true;
                            $scope.lat = 40.4168;
                            $scope.lng = -3.7038;
                            $scope.address = 'España';

                            if(scope.lat && scope.long){
                                def = false;
                                $scope.lat = scope.lat;
                                $scope.lng = scope.long;
                                $scope.address = scope.address;
                            } 
                            
                            (function () {
                                NgMap.getMap('mapAddress').then( function(map){
                                    $scope.google.maps.event.trigger(map,'resize');
                                    map.setCenter({lat: $scope.lat, lng: $scope.lng});

                                    if(def){
                                        map.setZoom(6);
                                    }
                                });
                            })();

                            $scope.getCurrentlocation = function(event){
                                getAddress(event.latLng.lat(), event.latLng.lng()).then(function(address){
                                    var streetNumber;
                                    angular.forEach(address.address_components, function(value, key) {
                                        switch (value.types[0]) {
                                            case 'street_number':
                                                streetNumber = value.long_name.toString();
                                                break;
                                            case 'locality': //city
                                                city = value.long_name;
                                                break;
                                            case 'administrative_area_level_2': //state
                                                province = value.long_name;
                                                break;
                                            case 'country': //country
                                                country = value.long_name;
                                                break;
                                            case 'postal_code': //cp
                                                cp = value.long_name;
                                                break; 
                                        }
                                    });
                                    $scope.address = address.formatted_address.toString().split(',')[0] + (streetNumber ? ', ' + streetNumber : '');
                                    $scope.lat = event.latLng.lat();
                                    $scope.lng = event.latLng.lng();
                                });
                            };

                            $scope.save = function () {
                                scope.address = $scope.address;
                                scope.lat = $scope.lat;
                                scope.long = $scope.lng;
                                if (scope.autocomplete) {
                                    if(scope.city)
                                        scope.city = city;

                                    if(scope.state)
                                        scope.state = province;

                                    if(scope.country)
                                        scope.country = country;

                                    if (scope.cp)
                                        scope.cp = cp;
                                }
                                $timeout(function () {
                                    if (scope.onChange) { scope.onChange(); }
                                    if (scope.onAddressChange) {
                                        scope.onAddressChange({
                                            address: {
                                                city: city,
                                                state: province,
                                                country: country,
                                                cp: cp,
                                                lat: scope.lat,
                                                lng: scope.long
                                            }
                                        });
                                    }
                                }, 0);

                                $rootScope.blurry = false;
                                close();
                            };

                            $scope.cancel = function () {
                                $rootScope.blurry = false;
                                close();
                            };
                            
                        }
                    });
                });

                function getAddress(lat, long) {
                    var geocoder = new google.maps.Geocoder();
                    var latlng = new google.maps.LatLng(
                        parseFloat(lat),
                        parseFloat(long)
                    );

                    var deferred = $q.defer();
                    geocoder.geocode(
                        { 'latLng': latlng },
                        function (results, status) {
                            if (status === google.maps.GeocoderStatus.OK) {
                                if (results[0]) {
                                    /*jshint camelcase: false */
                                    deferred.resolve(results[0]); return;
                                }
                            }
                            deferred.reject('Dirección no encontrada');
                        }
                    );
                    return deferred.promise;
                }

            }
        };
    }
})();